import type { ProductProps } from 'tsconfig/types';
import { Rating } from 'common-ui';

export const renderRating = (product: ProductProps | null) => {
  if (!product?.averageOverallRating || product.averageOverallRating <= 0) {
    return null;
  }

  return (
    <div className="product-rating">
      <Rating rating={product.averageOverallRating} />
      {product.totalReviewCount > 0 && <span>({product.totalReviewCount})</span>}
    </div>
  );
};
